import React from "react";
import styled from "styled-components";
import nota from "../../../Global/nota.guidelines.json";

import NanoFlex from "../../../Global/NanoFlex.js";
import Type from "../../../Global/Typography.js";

const multiple = nota.global.multiple;

const StyledSourceBlock = styled.div`
  width: 100%;
  p {
    &:after {
      content: "|";
      font-size: 12px;
      margin: 0 ${multiple / 2 + "px"};
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
  }
`;

const SourceBlock = (props) => {
  return (
    <StyledSourceBlock>
      <NanoFlex justifyContent={"flex-start"} alignItems={"flex-start"}>
        <Type.p>{props.source}</Type.p>
      </NanoFlex>
    </StyledSourceBlock>
  );
};

// Set default props
SourceBlock.defaultProps = {
  source: "", // 'Source'
};

export default SourceBlock;

// --- // Documentation // --- //
/*
import CardBlock from './../Nano/SourceBlock.js';

<SourceBlock 
    source={'Source'}
    results={'Audience Result'}
/>
*/
